import { DutySchedulingRowHeader } from "../../../../orval/gen"

export function collectContractIds(rowHeaders: DutySchedulingRowHeader[]): number[] {
  const contractIds = rowHeaders
    .filter((v) => v.rowType === "Contract" && v.id)
    .map((v) => v.id!)
  const subContractIds = rowHeaders.flatMap((v) =>
    collectContractIds(v.children || [])
  )
  return [...contractIds, ...subContractIds]
}
